import { render, staticRenderFns } from "./brakescheck.vue?vue&type=template&id=48335e5c&scoped=true"
import script from "./brakescheck.js?vue&type=script&lang=js&external"
export * from "./brakescheck.js?vue&type=script&lang=js&external"
import style0 from "./brakescheck.vue?vue&type=style&index=0&id=48335e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48335e5c",
  null
  
)

export default component.exports